import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { ImportCandidateService } from 'src/app/_services/import-candidate.service';

@Component({
    selector: 'app-csv-file-upload-model',
    templateUrl: './csv-file-upload-model.component.html',
    styleUrls: ['./csv-file-upload-model.component.scss'],
    standalone: false
})
export class CsvFileUploadModelComponent implements OnInit {

  /**
   * Uploaded CSV file
   */
  csvFile: File = null
  /**
   * Invalid file type when CSV is required
   */
  isInvalidCSV: boolean = false;
  /**
   * Invalid CSV file size
   */
  csvFileSizeError: boolean = false;
  /**
   * Indicates that the CSV file has passed validations
   */
  validatedCSV: boolean = false;
  /**
   * Indicates that the CSV file is being processed (API call)
   */
  isProcessingCSV: boolean = false;
  /**
   * Linkedin CSV import API response
   */
  linkedinCSVProcessingResponse: any = {};
  /**
   * Linkedin CSV API error
   */
  linkedinCSVError: string = ""

  @Input('insertSkipped') insertSkipped: boolean = false;

  successMessage: string = '';
  errorMessage: string = '';
  infoMessage: string = '';

  private _actionResolver = new Subject<any>()

  get actionResolver() {
    return this._actionResolver.asObservable()
  }

  @Output() event = new EventEmitter<any>();
  @Input() id: string;

  bulkSpinnerLoader: boolean = false;
  addBulkCandidateArray: any[] = [];
  


  constructor(
    private importCandidateService: ImportCandidateService,
    private activeModelService: NgbActiveModal

  ) { }

  ngOnInit() {
  }


  /**
 * Process uploaded CSV for linkedin import & basic validations
 * @param event HTML DOM event
 */
  uploadCSVFile(event: Event) {
    if ((event.target as HTMLInputElement).files && (event.target as HTMLInputElement).files.length > 0) {
      this.validatedCSV = false
      this.csvFile = null
      this.isInvalidCSV = false
      this.csvFileSizeError = false

      const receivedFile = (event.target as HTMLInputElement).files[0]
      this.csvFile = receivedFile
      const extension = receivedFile.name.split('.').pop().toLowerCase()

      // file type check
      if (extension != 'csv') {
        this.isInvalidCSV = true
        return
      }

      // file size > 10MB check
      if (receivedFile.size > 10 * 1024 * 1024) {
        this.csvFileSizeError = true
        return
      }
    }
  }

  /**
   * Submit CSV file to backend for processing
   */
  submitLinkedinCSV() {
    this.validatedCSV = false
    this.linkedinCSVError = ""
    if (this.csvFile && !(this.csvFileSizeError || this.isInvalidCSV)) {
      this.validatedCSV = true
    }

    this.isProcessingCSV = true

    this.importCandidateService.createCandidatesViaLinkedinCSVImport(this.csvFile).subscribe((res: any) => {
      this.isProcessingCSV = false
      if (res?.body?.status === 'success') {
        if (res?.body?.isLimitReached && res?.body?.isLimitReached == true) {
          this.successMessage = "Record limit exceeded. Only the first 500 records were processed.";
          setTimeout(() => { this.successMessage = '' }, 5000);
        }
        this.linkedinCSVProcessingResponse = res.body;
        this.proceedWithParshedCandidates(res?.body?.data);

      } else {
        this.linkedinCSVProcessingResponse = {}
        this.linkedinCSVError = `Something went wrong. Please contact administrator${res?.body?.error && res?.body?.error.code ? ` (${res?.body?.error.code})` : ''}`
      }
    }, (error) => {
      if (error && error.error && error.error?.message) {
        this.linkedinCSVProcessingResponse = {};
        this.linkedinCSVError = '';
        this.event.emit({ status: 'failed', message: error && error.error && error.error?.message });
        this.dismiss();
      } else {
        this.linkedinCSVProcessingResponse = {};
        this.linkedinCSVError = `Something went wrong.`;
        this.event.emit({ status: 'failed', message: 'Something went wrong!' });
        this.dismiss();
      }
    });
  }





  proceedWithParshedCandidates(data: Array<any>) {
    data.map((res: any) => {
      if(res.importstatus == 'successful') {
        this.addBulkCandidateArray.push({...res, importsource: 'csv'});
      } else if(res.importstatus == 'duplicate') {

      } else if(res.importstatus == 'unsuccessful') {

      }
    });

  };

/**
 * Create bulk candidate
 */
  addBulkCandidate() {
    if(!this.addBulkCandidateArray?.length) return;

    const data = {
      candidates: this.addBulkCandidateArray,
      talentpoolnumber: this.id
    }
    this.bulkSpinnerLoader = true;
    this.importCandidateService.createBulkCandidate(data).subscribe((res: any) => {
      if (res && res.body && res?.body?.status == 'success') {
        this.event.emit({ status: 'success', message: 'created' });
        this.activeModelService.close();
      } else {
        this.event.emit({ status: 'error', message: 'failed' });  
        this.activeModelService.close();
      };
      this.bulkSpinnerLoader = false;
    }, (error) => {
      this.event.emit({ status: 'error', message: 'failed' });  
      this.activeModelService.close();
      this.bulkSpinnerLoader = false;
    });
  };


  /**
   * Dismiss active model
   * @param type 
   */
  dismiss(type: string = '') {
    if(type?.trim()) this.event.emit({ status: 'cancel', message: 'cancel' });
    this.activeModelService.close();
  };

  /**
   * Method to download sample CSV file 
   */
  downloadSampleCSV() {
    this.importCandidateService.downloadSampleCsvFile().subscribe((res: Blob) => {
      const downloadUrl = URL.createObjectURL(res);
      const downloadLink = document.createElement("a");
      downloadLink.href = downloadUrl;
      downloadLink.download = 'SampleCSV.csv';
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      URL.revokeObjectURL(downloadUrl);
    }, (error) => {
      console.error('Download failed:', error);
    });
  };



}
